/* FILTER COMPONENT ***********************************************************/

/* react redux */
import React, {Component, PropTypes} from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

/* Actions */
import {
  saveFilter,
  fetchFilter
} from 'react-redux/actions/app'

/* Widgets */
import SearchInput from 'widget/search-input'

/* Styles */
import "./index.css"

/* Selectors */

import selector from './selector'

/* Global Filter Component (affects Assets, Playlists and MediaPlayers)*/
class Filter extends Component {

  componentDidMount() {
    const { fetchFilter, filter } = this.props
    if (!filter.initialized) fetchFilter()
  }

  filterItems(value) {
    const { saveFilter } = this.props
    saveFilter(value)
  }

  resetFilter(e) {
    const { saveFilter } = this.props
    saveFilter("")
  }

  render() {
    const { t, filter } = this.props
    return (
      <div className="filter-component">
        <SearchInput
          className="filter-input"
          type="text"
          onChange={ this.filterItems.bind(this) }
          onReset={ this.resetFilter.bind(this) }
          value={ filter.expression || "" }
          placeholder={ t("filter:searchInput.placeholder") }
        />
      </div>
    )
  }
}

Filter.propTypes = {}

const mapStateToProps = (state, props) => selector(state)



function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveFilter,
      fetchFilter
    },
    dispatch
  )
}

const reduxComponent = connect(mapStateToProps, mapDispatchToProps)(Filter)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/filter/index.jsx